import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { InputGeneral } from '../../inputs/input-general/input-general';

@Component({
  selector: 'app-modal-send-email',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, InputGeneral],
  templateUrl: './modal-send-email.component.html',
  styleUrl: './modal-send-email.component.scss',
})
export class ModalSendEmailComponent {
  public email: FormControl = new FormControl(null, [Validators.required, Validators.email]);
  constructor(
    public dialogRef: MatDialogRef<ModalSendEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { titule: string; text: string },
  ) {}

  public closeModal(): void {
    this.dialogRef.close(null);
  }

  public sentEmail(): void {
    this.dialogRef.close(this.email.value);
  }
}
